import React from 'react';
import AffiliateList from '../components/affiliate/AffiliateList';
import { getAffiliatesByJkaId } from '../view/HTTPService';

/**
 * /affiliatesByJkaId - Busca puro por JKA ID.
 * Não carrega lista inicial (fetchAffiliates={null}) - só busca.
 */
export default function AffiliatesByJkaIdPage() {
    return (
        <AffiliateList
            titleKey="msg.jkaAffiliatesByJkaId"
            fetchAffiliates={null}
            searchByJkaId={getAffiliatesByJkaId}
        />
    );
}
